import { Page, Text, Title } from 'components';
import React from 'react';
import styled from 'styled-components';
import Instructions from './Instructions';
import OpenHouseEditor from './OpenHouseEditor';
import OpenHouseFinder from './OpenHouseFinder';

const TriggerRetsOpenHouseUpdatePageContent: React.FC = () => (
  <Page type="filled" fillScreenHeight>
    <Layout>
      <Title level={1} hideMargin data-cy="page-title">
        Trigger RETS Open House Update QA Page
      </Title>
      <Text>
        This QA page is used to help trigger RETS update for open houses
      </Text>

      <Instructions />
      <OpenHouseFinder />
      <OpenHouseEditor />
    </Layout>
  </Page>
);

export default TriggerRetsOpenHouseUpdatePageContent;

const Layout = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 32px;
  padding: 20px;
  background: white;
`;
